var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { setFirstTimeFlags, unsetFirstTimeFlag } from './actions';
import { handleActions } from 'redux-actions';
var actionHandlers = handleActions((_a = {},
    _a[setFirstTimeFlags.toString()] = function (state, _a) {
        var flags = _a.payload;
        return (__assign(__assign({}, state), flags));
    },
    _a[unsetFirstTimeFlag.toString()] = function (state, _a) {
        var _b;
        var flag = _a.payload.flag;
        return (__assign(__assign({}, state), (_b = {}, _b[flag] = false, _b)));
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducers.js.map